import React from 'react';
export var SessionTagIcon = function SessionTagIcon(_a) {
  var className = _a.className;
  return React.createElement("svg", {
    className: className,
    width: "16",
    height: "16",
    viewBox: "0 0 31 31"
  }, React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0383 0.764002C14.4418 0.683287 14.8591 0.703458 15.253 0.822725C15.6469 0.941992 16.0053 1.15667 16.2963 1.44769L29.3529 14.5043C29.5851 14.7364 29.7692 15.012 29.8948 15.3153C30.0205 15.6187 30.0851 15.9437 30.0851 16.2721C30.0851 16.6004 30.0205 16.9254 29.8948 17.2288C29.7692 17.5321 29.5851 17.8077 29.3529 18.0398L18.0392 29.3535C17.8071 29.5857 17.5315 29.7698 17.2282 29.8955C16.9248 30.0211 16.5997 30.0858 16.2714 30.0858C15.9431 30.0858 15.618 30.0211 15.3147 29.8955C15.0114 29.7698 14.7358 29.5857 14.5037 29.3535L1.44708 16.2969C1.15605 16.0059 0.941382 15.6475 0.822115 15.2536C0.702848 14.8597 0.682677 14.4425 0.763392 14.0389L2.23426 14.333L0.763392 14.0389L2.77975 3.95706C2.89851 3.36327 3.36266 2.89912 3.95645 2.78036L14.0383 0.764002L14.3324 2.23487L14.0383 0.764002ZM14.3642 3.75822L5.52538 5.52599L3.75761 14.3648L16.2714 26.8787L26.878 16.2721L14.3642 3.75822Z",
    fill: "#AA9B8C"
  }), React.createElement("path", {
    d: "M9.5 11.5C10.6046 11.5 11.5 10.6046 11.5 9.5C11.5 8.39543 10.6046 7.5 9.5 7.5C8.39543 7.5 7.5 8.39543 7.5 9.5C7.5 10.6046 8.39543 11.5 9.5 11.5Z",
    fill: "#AA9B8C"
  }));
};